import { ShowChart } from "@mui/icons-material";
import { useCallback } from "react";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";
import { currentFeatures } from "../../configs/Settings";
import { ManagerContextProvider } from "@/contexts/ManagerContext";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { useLocationContext } from "@/contexts/LocationContext";
import ClinicalInsightsPage from "src-next/applications/mvp/pages/ClinicalInsightsPage";

/**
 * Rota legada — implementação em src-next (módulo clinical-insights + ClinicalInsightsPage).
 */
export function useClinicalAnalysis() {
  const { access } = useSessionContext();
  const { organization } = useOrganizationContext();
  const { location } = useLocationContext();

  const organizationId = organization?.id?.split("-")[1] || "";
  const locationActors =
    location?.map((loc) => loc.resource?.id).filter(Boolean) as string[] | undefined;

  const renderPage = useCallback(
    () => (
      <ManagerContextProvider>
        <ClinicalInsightsPage
          organizationId={organizationId}
          locationActors={locationActors ?? []}
          accessType={access?.type}
        />
      </ManagerContextProvider>
    ),
    [organizationId, locationActors, access?.type]
  );

  const configs: IFeatures = {
    active: access?.type === "professional" && currentFeatures.defaultApp,
    path: "/clinicalanalysis",
    icon: ShowChart,
    text: "Insights clínicos",

    subitem: true,
    parent: "Insights",

    sideMenu: true,
    sideMenuIndex: 0,

    avatarMenu: true,
    avatarIndex: 2,

    component: renderPage,
  };

  return configs;
}
